import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField, } from '../../../../../components';
import { Button, Container, Dialog, Grid, Paper, Stack, Typography, TextField as MuiTextField, Box, Radio, IconButton } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, getKeyPathValue, request, toast } from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { GENDER_DROPDOWN } from '../../../../../constants/dropdown';
import { AddTrayDetailsForm } from './AddTrayDetailsForm';
import CloseIcon from '@mui/icons-material/Close';


const initialPatientDataObj = {
    data: [],
    loading: false
};
const initialPosDataObj = {
    data: [],
    loading: false
};

const initialTrayRequestDataObj = {
    data: [],
    loading: false
};


const initialRequestTrayDataObj = {
    data: [],
    loading: false
};



export const TraySterilized = () => {
    const doctorIDRef = useRef();
    const { pathname } = useLocation();
    const lastPathSegment = pathname.split('/').pop();
    const [detailList, setDetailList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentAction, setCurrentAction] = useState();
    const [selectedRecord, setSelectedRecord] = useState();
    const [patientDataObj, setPatientDataObj] = useState(initialPatientDataObj);
    const [retailSalePosObj, setRetailSalePosObj] = useState(initialPosDataObj);
    const [indoorRegisterationDataObj, setIndoorRegisterationDataObj] = useState(initialPatientDataObj);
    const [trayRequestDataObj, setTrayRequestDataObj] = useState(initialTrayRequestDataObj);
    const [requestedTrayDataObj, setRequestTrayDataObj] = useState(initialRequestTrayDataObj);
    const [openQueryDialog, setOpenQueryDialog] = useState(false);
    const [originalData, setOriginalData] = useState([]);
    const [input, setInput] = useState('');
    const [isFiltered, setIsFiltered] = useState(false);
    const [opdDialogueOpen, setOpdDialogueOpen] = useState(false)
    const [ipdDialogueOpen, setIpdDialogueOpen] = useState(false)
    const [opdPatientDetail, setOpdPatientDetail] = useState([])
    const [ipdPatientDetail, setIpdPatientDetail] = useState([])
    const [tableData, setTableData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [qty, setQty] = useState('');
    const [opdData, setOpdData] = useState([])
    const [ipdData, setIpdData] = useState([])
    const [posInput, setPosInput] = useState('')
    const [opdInput, setOpdInput] = useState('')
    const [ipdInput, setIpdInput] = useState('')
    const [selectedRadio, setSelectedRadio] = useState('');
    const [posData, setPosData] = useState([])
    const [opdFilterData, setOpdFilterData] = useState({ data: [] });
    const [ipdFilterData, setIpdFilterData] = useState({ data: [] });
    const productRef = useRef()
    const [productStock, setProductStock] = useState([])
    const [doctorDropdown, setDoctorDropdown] = useState([])
    const [sponsorDropdown, setSponsorDropdown] = useState([]);
    const [wardDropdown, setWardDropdown] = useState([])
    const [roomMasterDropdown, setRoomMasterDropdown] = useState([]);
    const [warehouse, setWareHouse] = useState([])
    const [medicineDetailDialogue, setMedicineDetailDialogue] = useState(false)
    const [medicinesDetails, setMedicineDetails] = useState([])
    const [medicineReturnDetails, setMedicineReturnDetails] = useState([])
    const [labDetailDialogue, setLabDetailDialogue] = useState(false)
    const [labDetails, setLabDetails] = useState([])
    const [serviceDialogue, setServiceDialogue] = useState(false)
    const [serviceDetails, setServiceDetails] = useState([])
    const [indentData, setIndentData] = useState([])
    const [selectedIndentRadio, setSelectedIndentRadio] = useState('ipd_indent')
    const [originalOpdData, setOriginalOpdData] = useState([])
    const [cssdDialogueOpen, setCssdDialogeOpen] = useState(false)

    const { getValues } = useForm()
    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                // location_to: Yup.string().required(' '),
            })
        ),
        defaultValues: {
            date: new Date().toISOString().split('T')[0],
            time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),
        },
        mode: 'all'
    });
    const { handleSubmit, watch, reset, setValue } = methods;

    const REQUESTED_TABLE_HEADER = [
        { header: 'Tray Name', accessor: (row) => row?.items?.map(item => item.tray_name), },
        { header: 'Created By', accessor: 'created_by' },
    ];

    const AVAILABLE_TABLE_HEADER = [
        { header: 'Tray Number', accessor: (row) => row?.items?.map(item => item.tray_name), },
        { header: 'Created By', accessor: 'created_by' },
    ];

    const STERILIZED_TABLE_HEADER = [
        { header: 'Tray Number', accessor: (row) => row?.items?.map(item => item.tray_name), },
        { header: 'Created By', accessor: 'created_by' },
    ];


    const TABLE_HEADER = [
        { header: 'Req No.', accessor: 'req_no' },
        { header: 'Uhid', accessor: 'uhid' },
        { header: 'Ipd No', accessor: 'ipd_no' },
        { header: 'Patient Name', accessor: (row) => `${row?.patientInfo?.name_suffix}${row?.patientInfo?.first_name}${row?.patientInfo?.last_name}` },

    ];

    const getDoctorDropdown = useCallback(async () => {
        const data = await dropdownFetch('doctor');
        if (!selectedRecord && !getValues('consultant')) {
            const [defaultState] = data.filter(({ status }) => status === 'default');
            setValue('consultant', defaultState?._id);
            if (defaultState) {
                setValue('department', defaultState.qualification_details.department);
            }
        }

        setDoctorDropdown(data);
    }, [selectedRecord, getValues, setValue]);

    const getWardDropdown = useCallback(async () => {
        const data = await dropdownFetch('ward');
        setWardDropdown(data);
    }, []);

    const getRoomMasterDropdown = useCallback(async () => {
        const data = await dropdownFetch('room-master');
        setRoomMasterDropdown(data);
    }, []);


    const getWareHouseDropdown = useCallback(async () => {
        const data = await dropdownFetch('warehouse');
        setWareHouse(data);
    }, []);

    const getSponsorDropdown = useCallback(async () => {
        const data = await dropdownFetch('sponsor');
        if (!selectedRecord) {
            const [defaultSponsor] = data.filter(({ status }) => status === 'default');
            setValue('sponsor', defaultSponsor?._id);
        }
        setSponsorDropdown(data);
    }, []);

    useEffect(() => {
        getDoctorDropdown()
        getSponsorDropdown()
        getWardDropdown()
        getRoomMasterDropdown()
        getWareHouseDropdown()
    }, [getDoctorDropdown, getSponsorDropdown, getWardDropdown, getRoomMasterDropdown, getWareHouseDropdown])





    const formSubmit = async (formValues) => {
        setLoading(true);
        const items = medicinesDetails
        const payload = {
            ...formValues,
            items,
        };
        const editFlag = selectedRecord && currentAction === 'edit';
        try {
            const response = await request(editFlag ? `/indent-update/${selectedRecord._id}` : '/', {
                method: editFlag ? 'PUT' : 'POST',
                body: payload,
            });

            if (response?.success && response.data) {
                toast(`Successfully ${editFlag ? 'edited' : 'created'} Tray Request`, { variant: 'success' });
                setSelectedRecord(response.data);
                setCurrentAction();
                setLabDetails([])
                setServiceDetails([])
                setMedicineDetails([])
                reset()
            } else {
                toast(`Failed to ${editFlag ? 'edit' : 'create'} Tray Request`, { variant: 'error' });
            }
        } catch (error) {
            console.error("Error submitting the form:", error);
            toast("An error occurred while processing your request", { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };



    const handleRowDelete = (row) => {
        console.log("HELLLO ID OF ROW", row)
        setMedicineDetails((prev) => prev.filter((data) => data.tray_name !== row));
    };




    useEffect(() => {
        if (productStock && productStock.length > 0) {
            setOriginalData(productStock);
            setIsFiltered(false);
        }
    }, [productStock]);

    const handleProductSearch = (searchValue) => {
        const lowercasedInput = searchValue.toLowerCase();
        const filtered = indoorRegisterationDataObj.filter((item) =>
            item.productDetails[0].product?.toString().toLowerCase().includes(lowercasedInput)
        );
        setOriginalData(filtered);
    };

    const handleChangelk = (e) => {
        const newInput = e.target.value;
        setInput(newInput);
        handleProductSearch(newInput);
    };


    const calculateAge = (dob) => {
        const birthDate = new Date(dob);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();
        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };

    const handleRowClick = (row) => {
        console.log("HELLLLO ROW", row)
        setValue('patient_name', row?.patient?.name)
        setValue('uhid', row?.uhid)
        setValue('ipd_no', row?.ipd_no)
        setValue('consultant', row?.patientInfo?.consultant)
        setValue('gender', row?.patientInfo?.gender)
        setValue('age', calculateAge(row?.patientInfo?.dob))
        setValue('room', row?.patientIpdInfo?.consultant_detail?.room)
        setValue('ward', row?.wardInfo?._id)
        setValue('bed_no', row?.patientIpdInfo?.consultant_detail?.bed_no)
        setValue('sponsor', row?.patientInfo?.sponsor)
    };

    const handleRowOpdClick = (row) => {
        console.log("HELLLLO ROW", row)
        setValue('patient_name', `${row?.name_suffix}${row?.first_name}  ${row?.last_name}`)
        setValue('gender', `${row?.gender}`)
        setValue('age', calculateAge(row?.dob))
        setValue('uhid', row?.uhid)
        setValue('consultant', row?.consultant?._id)
        doctorIDRef.current = row?.consultant?._id;
        setValue('sponsor', row?.sponsor?._id)

    };


    const handleQtyChange = (e) => {
        setQty(e.target.value);
    };

    const fetchIpdPatient = async () => {
        setRequestTrayDataObj({ loading: true });
        const response = await request('/tray-request-list', { method: 'GET' });
        if (response.success) {
            const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setRequestTrayDataObj({ loading: false, data: sortedData });
            setIpdData(sortedData)
            setIpdFilterData({ data: sortedData });
        } else {
            toast('Error in fetching data', { variant: 'error' });
            setRequestTrayDataObj({ loading: false });
        }
    };

    useEffect(() => {
        fetchIpdPatient()
    }, [])

    const saleMode = watch('sale_mode')
    const handleOpdPatient = (row) => {
        setOpdPatientDetail(row)
        console.log("HELLO OPD PATEINT DETAILS", opdPatientDetail)
        setOpdDialogueOpen(false)
    }

    const handleIpdRow = (row) => {
        setIpdPatientDetail(row)
        console.log("HELLO IPD PATEINT DETAILS", ipdPatientDetail)
        setIpdDialogueOpen(false)
    }
    const handleAdd = () => {
        if (!selectedRow) return;
        const updatedRow = {
            ...selectedRow,
            bill_qty: qty,
        };
        const updatedTableData = tableData.some(row => row._id === selectedRow._id)
            ? tableData.map(row => row._id === selectedRow._id ? updatedRow : row)
            : [...tableData, updatedRow];
        setTableData(updatedTableData);
        setQty('');
        setSelectedRow(null);
        if (productRef.current) {
            productRef.current.focus();
        }
    };

    useEffect(() => {
        if (productRef.current) {
            productRef.current.focus();
        }
    }, []);

    const productData = tableData.map((row) => ({
        ...row,
        amount: row.rate * row.bill_qty,
    }));

    const ITEM_DETAIL_HEADER = [
        { header: 'Tray Type', accessor: 'tray_type' },
        { header: 'Assembled Date', accessor: 'assembled_date' },
        { header: 'Department', accessor: 'department' },
        { header: 'Status', accessor: 'status' },
    ];



    useEffect(() => {
        if (retailSalePosObj && retailSalePosObj.length > 0) {
            setPosData(retailSalePosObj);
            setIsFiltered(false);
        }
    }, [retailSalePosObj]);

    const handlePosData = (searchValue) => {
        const posDataArray = posData.data || [];
        const lowercasedInput = searchValue.toLowerCase();
        const filtered = posDataArray.filter((item) =>
            item.inv_no.toString().toLowerCase().includes(lowercasedInput)
        );
        setPosData({ ...posData, data: filtered });
    };
    const handleChangePos = (e) => {
        const newInput = e.target.value;
        setPosInput(newInput);
        handlePosData(newInput);
    }


    useEffect(() => {
        if (opdData && opdData.length > 0) {
            setOpdFilterData({ data: opdData });
            setIsFiltered(false);
        }
    }, [opdData]);

    const handleOpdDataFilter = (searchValue) => {
        const opdDataArray = opdFilterData.data || [];
        const lowercasedInput = searchValue.toLowerCase();

        const filtered = opdDataArray.filter((item) =>
            item.uhid.toString().includes(lowercasedInput)
        );
        setOpdFilterData((prevData) => ({ ...prevData, data: filtered }));
    };

    const handleOpdChange = (e) => {
        const newInput = e.target.value;
        setOpdInput(newInput);
        handleOpdDataFilter(newInput);
    };

    useEffect(() => {
        if (indoorRegisterationDataObj && Array.isArray(indoorRegisterationDataObj.data)) {
            setIpdFilterData({ data: indoorRegisterationDataObj.data });
            setIsFiltered(false);
        }
    }, [indoorRegisterationDataObj]);

    const handleIpdDataFilter = (searchValue) => {
        const ipdDataArray = ipdFilterData?.data || [];
        const lowercasedInput = searchValue.toLowerCase();
        const filtered = ipdDataArray.filter((item) =>
            item.uhid.toString().includes(lowercasedInput) ||
            item.ipd_no.toString().includes(lowercasedInput)
        );
        setIpdFilterData((prevData) => ({ ...prevData, data: filtered }));
    };
    const handleIpdChange = (e) => {
        const newInput = e.target.value;
        setIpdInput(newInput);
        handleIpdDataFilter(newInput);
    };


    useEffect(() => {
        if (requestedTrayDataObj && Array.isArray(requestedTrayDataObj.data) && requestedTrayDataObj.data.length > 0) {
            setOriginalData(requestedTrayDataObj.data);
            setIsFiltered(false);
        }
    }, [requestedTrayDataObj.data]);


    useEffect(() => {
        if (patientDataObj && Array.isArray(patientDataObj.data) && patientDataObj.data.length > 0) {
            setOriginalOpdData(patientDataObj.data);
            setIsFiltered(false);
        }
    }, [patientDataObj.data]);

    useEffect(() => {
        handlePatientSearch(input);
        handleOpdPatientSearch(input)
    }, [input]);

    const handlePatientSearch = (searchInput) => {
        if (Array.isArray(requestedTrayDataObj.data)) {
            const lowercasedInput = searchInput.toLowerCase();
            const filtered = requestedTrayDataObj.data.filter((item) => {
                const IpdMatch = item.ipd_no.toString().toLowerCase().includes(lowercasedInput)
                const firstNameMatch =
                    item.patient &&
                    item.patient.name &&
                    item.patientInfo.first_name.toLowerCase().includes(lowercasedInput);

                return IpdMatch || firstNameMatch;
            });
            setOriginalData(filtered);
            setIsFiltered(true);
        }
    };

    const handleOpdPatientSearch = (searchInput) => {
        if (Array.isArray(patientDataObj.data)) {
            const lowercasedInput = searchInput.toLowerCase();
            const filtered = patientDataObj.data.filter((item) => {
                const uhidMatch = item.uhid && item.uhid.toString().toLowerCase().includes(lowercasedInput);
                const firstNameMatch =
                    item.first_name &&
                    item.first_name &&
                    item.first_name.toLowerCase().includes(lowercasedInput);

                return uhidMatch || firstNameMatch;
            });

            setOriginalOpdData(filtered);
            setIsFiltered(true);
        }
    };


    const handleChange = (e) => {
        const newInput = e.target.value;
        setInput(newInput);
    };




    const handleQueryWindow = async () => {
        setOpenQueryDialog(true);
        setTrayRequestDataObj({ loading: true });
        const response = await request('/tray-request-list', { method: 'GET' });
        if (response?.success) {
            const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setTrayRequestDataObj({ loading: false, data: sortedData });
        } else {
            toast('Error in fetching data', { variant: 'error' });
            setTrayRequestDataObj({ loading: false });
        }
    };

    const handleRadioIndentChange = (event) => {
        const { name } = event.target;
        setSelectedIndentRadio(name);
    }

    return (
        <>
            <Paper sx={{
                p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
                width: '100%',
                height: 'auto'
            }}>
                <Container
                    sx={{
                        mt: 1,
                        border: '0px solid',
                        borderColor: 'grey.300',
                        borderRadius: 1,
                        width: '100%',
                        maxWidth: 'none',
                        minWidth: "100%",
                        boxSizing: 'border-box',
                    }}
                >
                    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)} >
                        <Stack
                            direction="row"
                            spacing={2}
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{
                                mb: 1,
                                borderBottom: '0px solid',
                                borderColor: 'grey.300'
                            }}
                        >
                            <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                                Tray Sterilized
                            </Typography>
                            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                                <CustomButtonn
                                    id={`${lastPathSegment}Write`}
                                    variant="contained"
                                    disabled={['edit', 'new'].includes(currentAction)}
                                    onClick={() => {
                                        setSelectedRecord();
                                        setCurrentAction('new');
                                        setDetailList([])
                                        setMedicineDetails([])
                                        setServiceDetails([])
                                        setLabDetails([])
                                        reset()
                                    }}
                                >
                                    New
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Update`}
                                    variant="contained"
                                    disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                                    onClick={() => setCurrentAction('edit')}
                                >
                                    Edit
                                </CustomButtonn>
                                <CustomButtonn
                                    id={"Submit"}
                                    type="submit"
                                    variant="contained"
                                    disabled={!['edit', 'new'].includes(currentAction) || loading}
                                >
                                    Save
                                </CustomButtonn>
                                <CustomButtonn
                                    id={"Cancel"}
                                    variant="contained"
                                    disabled={['edit', 'new'].includes(currentAction) || loading}
                                    onClick={() => {
                                        setCurrentAction();
                                    }}
                                >
                                    Cancel
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`isSuperAdmin`}
                                    variant="contained"
                                    disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                                >
                                    Delete
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Read`}
                                    variant="contained"
                                    disabled={['new', 'edit'].includes(currentAction)}
                                    onClick={() => {
                                        handleQueryWindow()
                                    }}
                                >
                                    Query
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Print`}
                                    variant="contained"
                                    onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                                    disabled={!selectedRecord || currentAction}
                                >
                                    Print
                                </CustomButtonn>
                                <CustomButtonn id={"Exit"} variant="contained"
                                    onClick={() => {
                                        setCurrentAction('');
                                    }}
                                >Exit</CustomButtonn>
                            </Stack>
                        </Stack>
                        <Box sx={{ border: '0px solid gray', padding: 2, borderRadius: '8px', width: '100%', boxShadow: '0px 2px 10px #0099ff' }}>
                            <Grid container spacing={1}>
                                <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                                    <Grid item sx={{ display: 'flex', flexDirection: 'column', marginTop: "1%" }}>
                                        <Stack spacing={0.2} direction="row" alignItems="center">
                                            <Radio
                                                disabled={!['new', 'edit'].includes(currentAction)}
                                                sx={{
                                                    flex: 0.3,
                                                }}
                                                name="available"
                                                checked={selectedIndentRadio === 'available'}
                                                onChange={handleRadioIndentChange}

                                            />
                                            <Typography sx={{ fontWeight: 700, fontSize: '1.4rem' }}>Available</Typography>
                                            <Radio
                                                disabled={!['new', 'edit'].includes(currentAction)}
                                                sx={{
                                                    flex: 0.2,
                                                }}
                                                name="requested"
                                                checked={selectedIndentRadio === 'requested'}
                                                onChange={handleRadioIndentChange}

                                            />
                                            <Typography sx={{ fontWeight: 700, fontSize: '1.4rem' }}>Requested</Typography>
                                            <Radio
                                                disabled={!['new', 'edit'].includes(currentAction)}
                                                sx={{
                                                    flex: 0.2,
                                                }}
                                                name="sterilized"
                                                checked={selectedIndentRadio === 'sterilized'}
                                                onChange={handleRadioIndentChange}

                                            />
                                            <Typography sx={{ fontWeight: 700, fontSize: '1.4rem' }}>Sterilized</Typography>
                                        </Stack>
                                        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
                                            <MuiTextField
                                                sx={{
                                                    width: '100%',
                                                    '& .MuiOutlinedInput-root': {
                                                        padding: '0',
                                                    },
                                                    '& .MuiOutlinedInput-input': {
                                                        padding: '8px 14px',
                                                        fontSize: '1.4rem',  // Increase the font size of the input text
                                                    },
                                                    '& .MuiInputLabel-root': {
                                                        fontSize: '1.4rem',  // Increase the font size of the label
                                                    },
                                                }}
                                                label="Search Admitted Patient"
                                                variant="outlined"
                                                value={input}
                                                onChange={handleChange}
                                                inputRef={productRef}
                                            />
                                        </Stack>

                                        {
                                            selectedIndentRadio === 'requested' ? (
                                                <Table
                                                    containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                                                    data={currentAction === 'new' ? originalData : []}
                                                    columns={REQUESTED_TABLE_HEADER}
                                                    size="small"
                                                    onRowClick={(row) => {
                                                        handleRowClick(row);
                                                    }}
                                                />
                                            ) : (
                                                <Table
                                                    containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                                                    data={currentAction === 'new' ? originalOpdData : []}
                                                    columns={AVAILABLE_TABLE_HEADER}
                                                    size="small"
                                                    onRowClick={(row) => {
                                                        handleRowOpdClick(row);
                                                    }}
                                                />
                                            )
                                        }
                                    </Grid>
                                </Grid>

                                <Grid item xs={8} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                                    <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row', gap: 0.3, marginTop: "7%" }}>
                                        <Table
                                            containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                                            data={[
                                                ...medicinesDetails.map((data) => ({ _id: data.tray_name, ...data })),
                                            ]}
                                            columns={ITEM_DETAIL_HEADER}
                                            size="small"
                                            showDeleteAction={true}
                                            onDeleteHandler={handleRowDelete}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </FormProvider>
                </Container >
            </Paper >


            <Dialog
                open={cssdDialogueOpen}
                onClose={() => setCssdDialogeOpen(false)}
                PaperProps={{ sx: { width: '60%', height: '70vh', p: 2 } }}
                maxWidth="xl"
                scroll="body"
            >
                <AddTrayDetailsForm
                    onClose={() => setCssdDialogeOpen(false)}
                    onAdd={(row) => {
                        setMedicineDetails((prev) => [...prev, row]);
                        setMedicineReturnDetails((prev) => [...prev, row]);
                    }}
                />
            </Dialog>

            <Dialog
                open={openQueryDialog}
                onClose={() => setOpenQueryDialog(false)}
                PaperProps={{ sx: { width: '80%', p: 2 } }}
                maxWidth="xl"
                scroll="body"
            >
                <Stack
                    padding={0}
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="space-between"
                    borderBottom="1px solid"
                    borderColor="grey.300"
                >
                    <Typography variant="h4" fontWeight="bold">
                        Tray Request Query Window
                    </Typography>
                    <IconButton onClick={() => setOpenQueryDialog(false)}>
                        <CloseIcon color="error" fontSize="large" />
                    </IconButton>
                </Stack>
                <Stack>
                    <MuiTextField
                        sx={{
                            width: '100%',
                            '& .MuiOutlinedInput-root': {
                                padding: '0',
                                fontSize: '1.4rem' // Adjust input font size
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: '8px 1.4rem'
                            },
                            '& .MuiInputLabel-root': {
                                fontSize: '1.2rem' // Adjust label font size
                            }
                        }}
                        label="Search Trays"
                        variant="outlined"
                        value={input}
                        InputProps={{
                            style: {
                                fontSize: '12px',
                                fontWeight: 600
                            },
                        }}
                    />
                </Stack>
                <Table
                    sx={{ mt: 0.5 }}
                    columns={TABLE_HEADER}
                    data={trayRequestDataObj.data || []}
                    loading={trayRequestDataObj.loading}
                    onRowClick={(row) => {
                        setSelectedRecord(row);
                        setOpenQueryDialog(false);
                    }}
                />
            </Dialog>
        </>
    );
};
